const errCodes = Object.freeze({
  SUCCESS: '0',
	ID_NOT_FOUND: '9000', // 아이디 없음(서버정보에)
	PASSWORD_ERROR: '9001', // 비밀번호 오류
	ALREADY_SIGNED: '9002', // 이미 로그인 중
	BLOCKED: '9003', // 블록된 계정
	ABNORMAL_APPROACH: '9004', // 비정상적 접근(권한없음)
	ERROR_CNT_OVER: '9005', // 오류횟수 초과
	EXPIRED_PASSWORD: '9006', // 비밀번호 만료
	INITIAL_PASSWORD: '9007', // 초기 비밀번호 사용중
	LIMITED_IP: '9008', // 제한된 아이피
	DISAGREE_PERSONAL_INFO: '9009', // 개인정보 이용 미동의
	LIMITED_ID: '9010', // 제한된 아이디
	EXPIRED_ID: '9011', // 아이디 사용기한 만료
  LOGIN_NEED_2ND_CERT: '9012', // 2차인증 필요

	SSO_NOT_USE: '9100', // 서버가 SSO를 사용하지 않음
	SSO_NOT_SIGNED: '9101', // SSO 로그인 상태가 아님
});

export default errCodes;
